<template>
    <div class="card p-1">
        <img class="card-img-top" :src="img" alt="Card image cap" />
        <div class="card-body">
            <h5 class="card-title">{{ title }}</h5>
            <p class="card-text">
                {{ body }}
            </p>
        </div>
        <div class="p-4">
            <a
                v-if="blankTarget.length > 0"
                :href="blankTarget"
                target="_blank"
                class="btn btn-primary w-100"
                >{{ buttonCaption }}</a
            >
            <router-link
                v-else-if="routerTarget.length > 0"
                :to="routerTarget"
                class="btn btn-primary w-100"
                >{{ buttonCaption }}</router-link
            >
        </div>
    </div>
</template>

<script>
export default {
    name: 'LinkCard',
    props: {
        img: {
            type: String,
            default: () => '',
            required: true,
        },
        title: {
            type: String,
            default: () => '',
        },
        body: {
            type: String,
            default: () => '',
        },
        buttonCaption: {
            type: String,
            default: () => '',
        },
        blankTarget: {
            type: String,
            default: () => '',
        },
        routerTarget: {
            type: String,
            default: () => '',
        },
    },
};
</script>

<style></style>
